module.exports = __webpack_public_path__ + "bin/b153572d07da0d2d17972b5500c64f0d.png";